import lazyLoadView from '@router/lazy-loader'
import ContainerView from './views/main'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `${routePrefix}`,
    component: ContainerView,
    meta: { moduleName, breadcrumbKey: 'user', nonLinked: true },
    children: [
      {
        path: ':userType',
        name: routeNamePrefix,
        component: () =>
          lazyLoadView(import(/* webpackChunkName: "users" */ './views/list')),
        meta: {
          titleFn(route, translator, pluralTranslator) {
            return pluralTranslator(route.params.userType)
          },
        },
      },
      {
        path: ':userType/create',
        name: `${routeNamePrefix}.create`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "users" */ './views/create')
          ),
        meta: {},
      },
      {
        path: ':userType/:id',
        name: `${routeNamePrefix}.edit`,
        component: () =>
          lazyLoadView(import(/* webpackChunkName: "users" */ './views/edit')),
        meta: {},
      },
    ],
  },
]
